export default "<button mat-button (click)=\"openDialog()\">Open dialog</button>\r\n"